import * as React from 'react';

import { CheckCircleOutlined, CloseCircleOutlined, StopOutlined } from '@ant-design/icons';

import { theme } from 'antd';

interface BooleanIconProps {
    value: boolean | null | undefined;
}

export const BooleanIcon: React.FC<BooleanIconProps> = (props) => {
    const antdTheme = theme.useToken().token;

    const baseIconStyle: React.CSSProperties = {
        fontSize: '1.5em',
    };

    switch (props.value) {
        case true: {
            return (
                <CheckCircleOutlined
                    style={{
                        ...baseIconStyle,
                        color: antdTheme.colorSuccess,
                    }}
                />
            );
        }
        case false: {
            return (
                <CloseCircleOutlined
                    style={{
                        ...baseIconStyle,
                        color: antdTheme.colorError,
                    }}
                />
            );
        }
        case null:
        case undefined:
        default: {
            return (
                <StopOutlined
                    style={{
                        ...baseIconStyle,
                        color: antdTheme.colorWarning,
                    }}
                />
            );
        }
    }
};